import styled from 'styled-components';

export const HorizontalLine = styled.div`
  flex-grow: 1;
  border-bottom: 1px solid #4948ac;
  align-self: center;
  margin: 10px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: BiotifSemiBold;
`;

export const ContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  font-size: 15px;
`;
export const RadioContainer = styled.div`
  display: flex;
  text-align: center;
  gap: 5px;
`;
